import React from 'react';
import { Features } from './components/Features';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="ventosas-page min-h-screen bg-cream font-sans text-brand-900 selection:bg-brand-500 selection:text-white" data-id="element-0" data-mp="3k89rlrzr0rhd">
      <MetaPixel data-id="element-1" data-mp="3f8eyriwexrto" />
      <Hero data-id="element-2" data-mp="2rkx3vehuqdmh" />
      <Features data-id="element-3" data-mp="2rknm2e6yncrv" />
      <Pricing data-id="element-4" data-mp="2rk4796clx4i2" />
    </div>;
}